import React from 'react';
import TaskCelebration from './TaskCelebration';
import IdeaDetailsModal from './IdeaDetails';
import TaskDetailsModal from './TaskDetails';
import { useDispatch, useSelector } from 'react-redux';
import { selectModalState, setModalOpen } from './store/slices/modal';
import Modal from '../components/modal';

export const MARK_TASK_COMPLETE_MODAL = 'mark_task_complete_modal';
export const IDEA_DETAILS_MODAL = 'idea_details_modal';
export const TASK_DETAILS_MODAL = 'task_details_modal';

const modals = {
  [MARK_TASK_COMPLETE_MODAL]: TaskCelebration,
  [IDEA_DETAILS_MODAL]: IdeaDetailsModal,
  [TASK_DETAILS_MODAL]: TaskDetailsModal
};

const RecommendationModalView = () => {
  const dispatch = useDispatch();
  const modalState = useSelector(selectModalState);
  const { activeModal, isOpen, recommendationId } = modalState;

  if (!activeModal) {
    return null;
  }

  const ModalDetails = modals[activeModal];
  if (!ModalDetails) {
    return null;
  }

  const toggleModal = (open) => () => {
    dispatch(setModalOpen({ isOpen: open }));
  };

  return (
    <>
      <Modal
        ariaHideApp={false}
        isCentered={true}
        width="LG"
        isOpen={isOpen}
        onRequestClose={toggleModal(false)}
        shouldCloseOnOverlayClick={true}
      >
        <ModalDetails
          onClick={toggleModal(false)}
          recommendationId={recommendationId}
        />
      </Modal>
    </>
  );
};

export default RecommendationModalView;
